/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.LessonChirpService
 */
import * as References from './LessonChirpService';
import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { registerQuery } from 'data-fetching-client/next';
export const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.LessonChirpService#getHydratedLesson
 */
export const GET_HYDRATED_LESSON_QUERY_FIELD_NAME = 'com_hubspot_academy_catalog_rpc_LessonChirpService_getHydratedLesson';
export const GET_HYDRATED_LESSON_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HYDRATED_LESSON_QUERY_FIELD_NAME,
  args: ['lessonId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getHydratedLessonRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.LessonChirpService#getHydratedLessons
 */
export const GET_HYDRATED_LESSONS_QUERY_FIELD_NAME = 'com_hubspot_academy_catalog_rpc_LessonChirpService_getHydratedLessons';
export const GET_HYDRATED_LESSONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HYDRATED_LESSONS_QUERY_FIELD_NAME,
  args: ['language', 'fallbackLanguage'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getHydratedLessonsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.catalog.rpc.LessonChirpService#getHydratedPartnerLessons
 */
export const GET_HYDRATED_PARTNER_LESSONS_QUERY_FIELD_NAME = 'com_hubspot_academy_catalog_rpc_LessonChirpService_getHydratedPartnerLessons';
export const GET_HYDRATED_PARTNER_LESSONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_HYDRATED_PARTNER_LESSONS_QUERY_FIELD_NAME,
  args: ['language', 'fallbackLanguage'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getHydratedPartnerLessonsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});